module.exports = __webpack_public_path__ + "static/media/14_crear_menu_plantilla_complejo_galeria_negra.6e4113e9.jpg";